export default (merchant, comment = '//') => {
  return merchant
    ? `${comment} This is your real test secret API key.`
    : `${comment} This is a sample test API key. Sign in to see examples pre-filled with your key.`;
};
